<!-- 头部 -->
<template> 
  <div :class="$store.state.app.collapse?'headbar-collapse':'headbar'">
    <!-- 工具栏 -->
    <div v-if="headOf8D" class="toolbarLeft" style="flot:left">{{$t('p0201.dReport')}}</div>

    <div class="toolbar" >
      <!-- 语言切换 -->
      <el-select v-model="language" @change="changeLanguage()">
        <el-option label="中文" value="zh" :disabled="$i18n.locale == 'zh'"></el-option>
        <!-- <el-option label="English" value="en" :disabled="$i18n.locale == 'en'"></el-option> -->
      </el-select>

      <!-- 用户名称、退出登录 -->
      <div class="userLogo">
        <!-- <img src="@/assets/user.png"/> -->
        <div>{{user}} <span class="exit" @click="logout()">&nbsp;&nbsp;&nbsp;{{$t('headBar.logout')}}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie"
import { mapState } from 'vuex'
export default {
  components:{
  },
  data() {
    return {
      language: '',
      user: '',
    }
  },
  methods: {
    // 折叠导航栏
    onCollapse: function() {
      this.$store.commit('onCollapse')
    },
    // 语言切换
    changeLanguage() {
      this.$confirm(this.$t('headBar.thisContinue'), this.$t('headBar.tips'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        // 更新localStorage中的值
        localStorage.setItem('locale', this.language)
        location.reload()
        setTimeout(() => {
          // 修改i18n的语言标志
          this.$i18n.locale = localStorage.getItem('locale')
          this.$message({
            type: 'success',
            message: '切换语言成功!'
          });
        }, 2000);
      }).catch(() => {
        this.language = this.$i18n.locale
      });
    },

    // 退出登录
    logout() {
      this.$confirm(this.$t('signOutPage.confirmMsg'), this.$t('signOutPage.signOut'), {})
        .then(() => {
          localStorage.removeItem('user')
          // localStorage.removeItem('userLastName')
          // localStorage.removeItem('userFirstName')
          localStorage.removeItem('userId')
          Cookies.remove('access_token')
          this.$http.get('/api/logout').then(res => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: this.$t("loginPage.Exitsuccess") 
              })
              this.$router.push('/login')
            }
          }).catch(e => {
            console.log(e)
          })
        })
        .catch(() => {
        })
    },
  },
  created () {
    this.language = this.$i18n.locale
    this.user = localStorage.getItem('user')
  },
  mounted() {

  },
  computed:{
    ...mapState({
      // themeColor: state=>state.app.themeColor,
      collapse: state=>state.app.collapse,
      headOf8D: state=>state.app.headOf8D,
      headOfselectCompany: state=>state.app.headOfselectCompany
    })
  }
}
</script>

<style scoped lang="scss">
.headbar {
  position: fixed;
  top: 0;
  left: 252px;
  right: 0;
  z-index: 1030;
  height: 58px;
  background-color: rgba(251, 251, 251, 1);
  border-width: 1px;
  border-style: solid solid solid none;
  border-color: rgba(121, 121, 121, 1);
}

.headbar-collapse {
  position: fixed;
  top: 0;
  left: 60px;
  right: 0;
  z-index: 1030;
  height: 58px;
  background-color: rgba(251, 251, 251, 1);
  border-width: 1px;
  border-style: solid solid solid none;
  border-color: rgba(121, 121, 121, 1);
}
.hamburg {
  float: left;
}

.toolbar {
  height: 58px;
  float: right;
}

>>>.el-input__inner {
  padding: 3px 5px 3px 5px;
  width: 70px;
  height: 25px;
  margin-top: 16.5px;
  font-family: 'Arial Normal', 'Arial';
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  text-align: left;
}

>>>.el-input__suffix {
  position: relative;
  top: 2px;
  left: -22px;
}

.toolbarLeft{
  height: 58px;
  float: left;
  line-height: 58px;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  font-weight: 700;
  font-style: normal;
  font-size: 18px;
  margin-left: 20px;
}

.userLogo {
  float: right;
  margin-top: 20px;
  margin-right: 20px;
  img {
    width: 17px;
    height: 19px;
  }
  div {
    float: right;
    font-family: 'Arial Normal', 'Arial';
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
  }
}
.companyStyle{
    float: left;
    margin-top: 20px;
    margin-right: 20px;
    font-size: 14px;
}

.exit {
  font-family: 'Arial Normal', 'Arial';
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  color: #0099FF;
  cursor: pointer;
}

>>>.el-menu--horizontal>.el-menu-item {
  height: 58px;
}

>>>.el-menu.el-menu--horizontal {
  border-bottom: none;
}

>>>.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: none;
}
</style>


// WEBPACK FOOTER //
// src/components/HeadBar/HeadBar.vue